import { useContext, useEffect, useState } from 'react';
import { getPageData, getUserActiveServicesCount } from '../../api/user/dashboard';
import { registerDomains, registerHostings } from '../../api/user/cart-pay';
import { errorMessage } from '../../api/global';
import { DISPLAY_LANG } from '../../config';
import { CartContext } from '../../contexts/CartContext';
import Loading from '../../components/loading';
import Modal from '../../components/user/dashboard/Modal';
import ActiveServices from '../../components/user/dashboard/ActiveServices';
import DomainTransfer from '../../components/user/dashboard/DomainTransfer';
import QuestionList from '../../components/user/dashboard/QuestionList';
import axios from '../../axios';
import '../../stylesheets/user/user-dashboard.css';

export default function UserDashboard() {
    const [dashboardData, setDashboardData] = useState(null);
    const [activeServicesCount, setActiveServicesCount] = useState(null);
    const [questionData, setQuestionData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showActiveService, setShowActiveServices] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(null);

    const { loadingOrders } = useContext(CartContext);

    useEffect(() => {
        const start = async () => {
            const payCartList = async () => {
                /* ================== loading cart data ================== */
                const userId = localStorage.getItem('user_id');
                const cartItems = await axios.get(`users/cart/${userId}`);
                const orders = cartItems.data.items;
                /* ================== end cart data ================== */

                const result = await checkPayment();

                if (result.status === 'success') {
                    /**
                        @description
                        ete ays if-i mej enq, nshanakum e vor gnum@ hajoxutyamb katarvel e
                        ev hima petq e registracia anenq klienti karzinki meji tvyalner@
                    */

                    try {
                        await registerDomains();
                        localStorage.removeItem('domain_registration_contacts');

                        await registerHostings(orders);

                        /**
                         * =========================================================
                         * @HOSTING_UPGRADE
                         * sa ayn depqn e, vor erb vor klient@ hosting patet e
                         * upgrade arel, ete chi arel, uremn ays qayl@ chi ashxati
                         * =========================================================
                         * */

                        const HOSTING_UPGRADE_SELECTED_PLAN_NAME = localStorage.getItem('100_HOSTING_UPGRADE_SELECTED_PLAN_NAME');
                        const HOSTING_UPGRADE_CURRENT_USERNAME = localStorage.getItem('100_HOSTING_UPGRADE_CURRENT_USERNAME');
                        const HOSTING_UPGRADE_SELECTED_PLAN_BILLING_TYPE = localStorage.getItem('100_HOSTING_UPGRADE_SELECTED_PLAN_BILLING_TYPE');
                        const HOSTING_UPGRADE_CURRENT_DOMAIN_NAME = localStorage.getItem('100_HOSTING_UPGRADE_CURRENT_DOMAIN_NAME');
                        const HOSTING_OLD_PRICE = localStorage.getItem('100_HOSTING_OLD_PRICE');

                        if (HOSTING_UPGRADE_SELECTED_PLAN_NAME && HOSTING_UPGRADE_SELECTED_PLAN_BILLING_TYPE && HOSTING_UPGRADE_CURRENT_USERNAME) {
                            try {
                                const res = await axios.post('isp/upgrade_hosting', {
                                    username: HOSTING_UPGRADE_CURRENT_USERNAME,
                                    plan: HOSTING_UPGRADE_SELECTED_PLAN_NAME,
                                    billing_type: HOSTING_UPGRADE_SELECTED_PLAN_BILLING_TYPE,
                                    domain: HOSTING_UPGRADE_CURRENT_DOMAIN_NAME,
                                    old_hosting_price: HOSTING_OLD_PRICE,
                                });

                                if (res.status !== 200) {
                                    throw new Error('Error upgrading hosting');
                                }

                                alert(res.data.message[DISPLAY_LANG]);

                                localStorage.removeItem('100_HOSTING_UPGRADE_SELECTED_PLAN_NAME');
                                localStorage.removeItem('100_HOSTING_UPGRADE_SELECTED_PLAN_BILLING_TYPE');
                                localStorage.removeItem('100_HOSTING_UPGRADE_CURRENT_USERNAME');
                                localStorage.removeItem('100_HOSTING_UPGRADE_CURRENT_DOMAIN_NAME');
                                localStorage.removeItem('100_HOSTING_UPGRADE_CURRENT_DOMAIN_NAME');
                                localStorage.removeItem('100_HOSTING_OLD_PRICE');
                            } catch (error) {
                                console.log(error);
                                alert(errorMessage[DISPLAY_LANG] + ', ' + error.message);
                            }
                        }

                        /**
                        * =========================================================
                        * @HOSINTG_RENEW
                        * sa ayn depqn e, vor erb vor klient@ hosting@
                        * renew e arel, ev ete vhcarum@ exel e, menq el enq renew anum
                        * =========================================================
                        * */

                        const HOSTING_RENEW_DOMAIN_NAME = localStorage.getItem('200_HOSTING_RENEW_DOMAIN_NAME');
                        const HOSTING_RENEW_BILLING_TYPE = localStorage.getItem('200_HOSTING_RENEW_BILLING_TYPE');

                        if (HOSTING_RENEW_DOMAIN_NAME && HOSTING_RENEW_BILLING_TYPE) {
                            try {
                                const res = await axios.post('isp/renew_hosting', {
                                    domain: HOSTING_RENEW_DOMAIN_NAME,
                                    billing_type: HOSTING_RENEW_BILLING_TYPE,
                                });

                                if (res.status !== 200) {
                                    throw new Error('Error renewing hosting');
                                }

                                alert(res.data.message[DISPLAY_LANG]);

                                localStorage.removeItem('200_HOSTING_RENEW_DOMAIN_NAME');
                                localStorage.removeItem('200_HOSTING_RENEW_BILLING_TYPE');
                            } catch (error) {
                                console.log(error, error.message);
                                alert(errorMessage[DISPLAY_LANG] + ', ' + error.message);
                            }
                        }

                    } catch (error) {
                        console.log(error);
                        alert(errorMessage[DISPLAY_LANG])
                    }

                    setModalData(result);
                    setShowModal(true);
                    checkPaymentStatus(result.paymentID);
                }

                if (result.status === 'failed') {
                    setModalData(result);
                    setShowModal(true);
                }

                if (result.status === 'empty') {
                    // cookinern em maqrum
                    document.cookie.split(";").forEach((cookie) => {
                        const name = cookie.split("=")[0].trim();
                        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                    });
                };
            };

            const loadingData = async () => {
                try {
                    const resPage = await getPageData();
                    setDashboardData(resPage.pageData);
                    setQuestionData(resPage.question);

                    const resCount = await getUserActiveServicesCount();
                    setActiveServicesCount(resCount);

                    const allZero = Object.values(resCount).every(
                        item => item.count === 0 || item.count === '0'
                    );

                    setShowActiveServices(!allZero);

                    setLoading(false);
                } catch (error) {
                    console.log(error);
                    alert(errorMessage[DISPLAY_LANG]);
                    setLoading(false);
                }
            };

            await payCartList();
            await loadingData();
            await loadingOrders();
            window.scrollTo(0, 0);
        }

        start();
    }, []);

    const checkPayment = async () => {
        // stugum em te banki het, vharum@ vonc a exel

        const params = new URLSearchParams(window.location.search);

        if (params.size) {
            const responseCode = params.get("responseCode");
            const paymentID = params.get("paymentID") || null;

            if (responseCode === "00") {
                console.log("✅ ՕԿ։ Վճարումը հաջող է։");

                const message = {
                    "am": "Գնումը հաջողությամբ կատարվեց",
                    "ru": "Покупка успешно завершена",
                    "en": "The purchase was successful",
                };

                return { status: "success", paymentID, message };
            } else {
                console.log("❌ Ոչ։ Վճարումը ձախողվեց։");

                const message = {
                    en: "The payment was unsuccessful./The bank may have declined the transaction or a technical error occurred.",
                    ru: "Платёж не удался./Возможно, банк отклонил транзакцию или произошёл технический сбой.",
                    am: "Վճարումը չի հաջողվել։/Հնարավոր է բանկը մերժել է գործարքը կամ տեխնիկական խափանում է տեղի ունեցել։",
                }

                return { status: "failed", message };
            }
        }

        return { status: "empty" };
    };

    const checkPaymentStatus = async (paymentID) => {
        // sa uxxaki drel enq, bankna panajum, vochmi logika chkpa pahvac

        // const body = {
        //     PaymentID: paymentID,
        //     Username: process.env.REACT_APP_PAYMENT_USERNAME,
        //     Password: process.env.REACT_APP_PAYMENT_PASSWORD,
        // };

        // await axios.post('check_payment_status/', body);
    };

    if (loading) {
        return <Loading />
    }

    return (
        <div className="UserDashboard wrapper">
            {showModal && <Modal modalData={modalData} setModalData={setModalData} setShowModal={setShowModal} />}
            <ActiveServices showActiveService={showActiveService} pageData={dashboardData} activeServicesCount={activeServicesCount} />
            <DomainTransfer pageData={dashboardData} />
            <QuestionList questionData={questionData} />
        </div>
    )
}
